import { AnalyticService } from '@application/analytic/analytic.service';
import { useAnalyticContext } from '@application/analytic/analytic_context.provider';
import { HostingService } from '@application/hosting.service';
import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { Flex, Stack, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { useResolve, useService } from '@visiba/instantiation';
import { rem } from '@visiba/std';
import styled from 'styled-components';

const elements = {
	link: styled.a`
		line-height: ${rem(24)};
		font-size: ${rem(24)};
	`,
	linkIconContainer: styled.div`
		color: ${tokens.color.content.interactive};
		flex-shrink: 0;
	`,
	appLogoImage: styled.img`
		height: ${rem(45)};
	`,
	appLink: styled.a`
		display: block;
	`,
};

export function AppSection(): JSX.Element | null {
	const universalConfig = useResolve(UniversalConfig);
	const hostingService = useResolve(HostingService);

	const appConfig = universalConfig.appConfig;

	if (appConfig?.androidPackageId == null || appConfig?.appStoreId == null) return null;

	return (
		<Stack gap={tokens.spacing.x1}>
			<Text variant='bodySemiBold' color={tokens.color.content.brand}>
				{withTranslation('PW.Component.Footer.DownloadApp.Title')}
			</Text>
			<Flex gap={tokens.spacing.x0_5} direction='row'>
				{appConfig?.androidPackageId && appConfig?.androidDownloadLink ? (
					<elements.appLink
						role='link'
						aria-label={withTranslation('PW.Component.Footer.DownloadApp.label.Android')}
						href={appConfig.androidDownloadLink}
						target='_blank'
					>
						<elements.appLogoImage src={hostingService.assetPath + appConfig.androidImageUrl} alt='Google play store logo' />
					</elements.appLink>
				) : null}
				{appConfig?.appStoreId && appConfig?.iosDownloadLink ? (
					<elements.appLink
						role='link'
						href={appConfig.iosDownloadLink}
						aria-label={withTranslation('PW.Component.Footer.DownloadApp.label.IOS')}
						target='_blank'
					>
						<elements.appLogoImage src={hostingService.assetPath + appConfig.iosImageUrl} alt='App store logo' />
					</elements.appLink>
				) : null}
			</Flex>
		</Stack>
	);
}
